module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@2x-fc19abcf9500ef9ea83cb6f8e241cb26.png";